module.exports = __webpack_public_path__ + "img/Icon-download.192936cd.svg";